import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { StandardReportToken } from '@shared-store/base.action';
import * as _ from 'lodash';
import { Observable, of } from 'rxjs';
import { UserTokenResponse } from 'src/app/shared-resources/interfaces/base-core-services.interface';
import { StorageService } from 'src/app/shared-resources/services/storage.service';
import { UserInfoService } from 'src/app/shared-resources/services/user-info.service';
import { ENUM } from 'src/app/shared-resources/constants/common.constants';
import { CommonRdmService } from './common-rdm.service';
import { environment } from 'src/environments/environment';
import { LoginRequest } from '../interfaces/login.interface';
const keepLabels = [
  "ics.menu.worklistmgmt",
  "ics.menu.intelligencemgmt",
  "ics.menu.usermgmt",
  "ics.menu.customsvaluation",
  "ics.menu.declaration",
  "ics.menu.tariffmgmt",
  "ics.menu.refdata",
  "ics.menu.reports"
];
@Injectable()
export class LoginService {
  menuJson :any = [];
  reportBearerToken:string;

  constructor(
    private http: HttpClient,
    private userInfoService: UserInfoService,
    private storage: StorageService,
    private commonRdmService: CommonRdmService,
    private store:Store
  ) {}

  login(reg: LoginRequest): Observable<UserTokenResponse> {
    const url = environment.baseUrl + environment.wso2amEndPoint +
      environment.identityServerName +
      environment.wso2amApiVersion +
      '/public/v1/auth/login';
    return this.http.post<UserTokenResponse>(url, reg);
  }

  userDetails(reg: LoginRequest): Observable<UserTokenResponse> {
    const url = environment.baseUrl + environment.wso2amEndPoint +
      environment.identityServerName +
      environment.wso2amApiVersion +
      '/public/v1/auth/userdetails';
    return this.http.post<UserTokenResponse>(url, reg);
  }

  userGroups(member: string): Observable<string> {
    const url = environment.baseUrl + environment.wso2amEndPoint +
      '/bps' +
      environment.wso2amApiVersion +
      '/rest/engine/default/group';
    return this.http.get<string>(url, { params: { member } });
  }

  getUserProfilePic(photoPath: any): Observable<any> {
    const url = environment.baseUrl + environment.wso2amEndPoint +
      '/dms' +
      environment.wso2amApiVersion +
      `/api/v1/documents/${photoPath}/download/data`;
    return this.http.get(url);
  }

  setUserData(res: UserTokenResponse, userName: string) {    
    res.appMenuJson = _.filter(res.appMenuJson, item =>
      keepLabels.includes(item.label)
    );
    this.applyViewActionFilter(res.appMenuJson);
    // console.log('[LoginService] Menu after applyViewActionFilter:', JSON.stringify(res.appMenuJson.map((m: any) => ({ label: m.label, children: m.children?.map((c: any) => ({ label: c.label, children: c.children?.map((cc: any) => ({ label: cc.label, hide: cc.hide, actions: cc.actions })) })) }))));
    this.menuJson = res.appMenuJson;
    this.store.dispatch(new StandardReportToken());
    sessionStorage.setItem('modules',JSON.stringify(res.appMenuJson))
    // localStorage.setItem('modules',JSON.stringify(res.appMenuJson))
    res.user['userType'] = res.userType;
    res.user['userName'] = userName;
    res.user.token =
      res.token && res.token.accessToken
        ? res.token.accessToken
        : this.userInfoService.getUserToken();
    res.user.refreshToken =
      res.token && res.token.refreshToken
        ? res.token.refreshToken
        : this.userInfoService.geRefreshToken();
    res.user.isBootstrapUser = res.isBootstrapUser
    sessionStorage.setItem('token',res.token.accessToken? res.token.accessToken : this.userInfoService.getUserToken())
    sessionStorage.setItem('refreshToken', res.token.refreshToken? res.token.refreshToken: this.userInfoService.geRefreshToken());
    res.user.expiresIn =
      res.token && res.token.expiresIn ? res.token.expiresIn : 0;
    this.userInfoService.setUserInfo(res.user);
    this.userGroups(userName)?.subscribe((groups: any) => {
      this.userInfoService.setUserGroupInfo(groups);
    });
    // this.userInfoService.deleteCookies();
    this.userInfoService.setCustomerIdAndOrgId(res.user);
    this.userInfoService.setPortTypeAndPortCode(res.user);
  }

  public isAuthenticated(): boolean {
    // Check whether the token is expired and return
    // true or false
    const token = this.userInfoService.getUserToken();
    const userType = this.userInfoService.getUserType();
    const isOTPVerified = JSON.parse(String(sessionStorage.getItem('isOTPVerified'))); 
    if (_.isEmpty(token)) {
      return false;
    } else {
      if (
        ( window.location.href.indexOf('admin-ui') || window.location.href.indexOf('/intelligencesuite-ui') >= 0 || window.location.href.indexOf('/inventory-ui') >= 0 ) &&
        userType &&
        userType === 'admin_user'
      ) {
        return true;
      }
      if (
        window.location.href.indexOf('admin-ui') === -1 &&
        userType &&
        userType === 'consumer_user' && isOTPVerified
      ) {
        return true;
      } else {
        return false;
      }
    }
  }

  private readonly listingActions = [ENUM.SEARCH, ENUM.VIEW, ENUM.REVIEW, ENUM.CANCLE, ENUM.AMEND,ENUM.UPDATE];

  private readonly mandatoryActionMap: { [menuLabel: string]: string | string[] } = {
    'menu.intelligence.tariffManagement.preferential.create': ENUM.SUBMIT,
    'menu.intelligence.tariffManagement.preferential.search': this.listingActions,
    'ics.menu.tariffmgmt.tariff.create': ENUM.SUBMIT,
    'ics.menu.tariffmgmt.tariff.search': this.listingActions,
    'ics.menu.tariffmgmt.tariff.upload': ENUM.UPLOAD,
    'ics.menu.tariffmgmt.tariff.uploaded': this.listingActions,
    'menu.intelligence.tariffManagement.preferential.upload': ENUM.UPLOAD,
    'menu.intelligence.tariffManagement.preferential.uploaded': this.listingActions,
    'menu.tariffManagement.tariffcontrol.create': ENUM.SUBMIT,
    'menu.tariffManagement.tariffcontrol.search': this.listingActions,
    'menu.tariffManagement.tariffcontrol.uploadBulk': ENUM.UPLOAD,
    'menu.tariffManagement.tariffcontrol.uploaded': this.listingActions,
    'menu.intelligence.tariffManagement.ruling.create': ENUM.SUBMIT,
    'menu.intelligence.tariffManagement.ruling.search': this.listingActions,
    'ics.menu.customsvaluation.valuation.create': ENUM.SUBMIT,
    'ics.menu.customsvaluation.valuation.search': this.listingActions,
    'ics.menu.customsvaluation.valuation.calculator': ENUM.VIEW,
    'ics.menu.customsvaluation.masterdata.gold.price.create': ENUM.SUBMIT,
    'ics.menu.customsvaluation.masterdata.gold.price.search': this.listingActions,
    'ics.menu.customsvaluation.masterdata.vehicle.price.create': ENUM.SUBMIT,
    'ics.menu.customsvaluation.masterdata.vehicle.price.search': this.listingActions,
    'ics.menu.customsvaluation.masterdata.vehicle.price.upload': ENUM.UPLOAD,
    'ics.menu.customsvaluation.masterdata.vehicle.price.upload-view': this.listingActions,
    'ics.menu.customsvaluation.valueResult.declaration': this.listingActions,
    'ics.menu.customsvaluation.additional.create-indicator': ENUM.SUBMIT,
    'ics.menu.customsvaluation.additional.search-indicator': this.listingActions,
    'ics.menu.customsvaluation.additional.upload-indicator': ENUM.UPLOAD,
    'ics.menu.customsvaluation.additional.indicator.upload-view': this.listingActions,
    'ics.menu.customsvaluation.additional.create-hs-code-mapping': ENUM.SUBMIT,
    'ics.menu.customsvaluation.additional.search-hs-code-mapping': this.listingActions,
    'ics.menu.customsvaluation.additional.upload-hs-code-mapping': ENUM.UPLOAD,
    'ics.menu.customsvaluation.additional.hscode-mapping.upload-view': this.listingActions,

    // Intelligence Management - Profile Management
    'ics.menu.intelligencemgmt.profilemgmt.create': ENUM.SUBMIT,
    'ics.menu.intelligencemgmt.profilemgmt.search': this.listingActions,
    'ics.menu.intelligencemgmt.profilemgmt.upload': ENUM.UPLOAD,
    'ics.menu.intelligencemgmt.profilemgmt.reports': this.listingActions,

    // Intelligence Management - Risk Management (listing pages)
    // 'ics.menu.intelligencemgmt.riskmgmt.declaration': this.listingActions,
    // 'ics.menu.intelligencemgmt.riskmgmt.manifest': this.listingActions,
    // 'ics.menu.intelligencemgmt.riskmgmt.consolidatedBL': this.listingActions,
    // 'ics.menu.intelligencemgmt.riskmgmt.houseBL': this.listingActions,
    // 'intelligencemgmt.menu.riskManagement.cargoes_transfer': this.listingActions,
    // 'intelligencemgmt.menu.expressCourier': this.listingActions,
    // 'intelligencemgmt.menu.expressCourierBL': this.listingActions,

    // Intelligence Management - Risk Register
    'ics.menu.intelligencemgmt.riskregister.create': ENUM.SUBMIT,
    'ics.menu.intelligencemgmt.riskregister.serach': this.listingActions,
    // 'ics.menu.intelligencemgmt.riskregister.extSources': this.listingActions,

    // Intelligence Management - Risk Assessment
    'ics.menu.intelligencemgmt.sub.riskAssessment.Assessment': this.listingActions,

    // Intelligence Management - Settings
    'ics.menu.intelligencemgmt.settings.riskAssmt': this.listingActions,

    // Intelligence Management - Trusted Trader
    'ics.menu.intelligencemgmt.trustedTrader.create': ENUM.SUBMIT,
    'ics.menu.intelligencemgmt.trustedTrader.search': this.listingActions,

    // Intelligence Management - UNDG
    // 'ics.menu.intelligencemgmt.undg': this.listingActions,
    
    // Intelligence Management - Favourite List
    'ics.menu.intelligencemgmt.favourite-list.create': ENUM.SUBMIT,
    'ics.menu.intelligencemgmt.favourite-list.search': this.listingActions,

    // Reference Data - Master Data
    'ics.menu.system-admin.masterData.create': ENUM.SUBMIT,
    'ics.menu.system-admin.masterData.search': this.listingActions,
    'ics.menu.system-admin.masterData.uploaded': this.listingActions,

    // Reference Data - Exchange Rate
    'ics.menu.system-admin.exchangerate.viewall': this.listingActions,
    'ics.menu.system-admin.exchangerate.uploaded': this.listingActions,

    // Reference Data - Email Template
    'ics.menu.system-admin.emailTemplate.search': this.listingActions,

    // User Management - Roles
    'ics.menu.usermgmt.roles.create': ENUM.SUBMIT,
    'ics.menu.usermgmt.roles.search': this.listingActions,

    'ics.menu.usermgmt.users.create': ENUM.SUBMIT,
    'ics.menu.usermgmt.users.search': this.listingActions,
    'ics.menu.usermgmt.users.upload': ENUM.UPLOAD,
  };

  private applyViewActionFilter(menuItems: any[]): void {
    menuItems.forEach((item: any) => {
      if (item.children && item.children.length > 0) {
        this.applyViewActionFilter(item.children);
      }
      const required = this.mandatoryActionMap[item.label];
      if (required && item.actions) {
        const allowed = (Array.isArray(required) ? required : [required]).map((a: string) => a.toLowerCase());
        if (!item.actions.some((a: string) => allowed.includes(a.toLowerCase()))) {
          item.hide = true;
        }
      }
    });
  }

  getNotifyInfo(userId: string, token: string): Observable<any> {
    const url = `${environment.baseUrl}/nsm/api/v1/notify?userId=${userId}`;
    return this.http.get<any>(url, { headers: { Authorization: `Bearer ${token}` } });
  }

  getUnreadCount(userId: string): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl}/nsm/api/v1/user-notifications/${userId}/unread-count`);
  }

  getNotifications(userId: string, page = 0, size = 10, isRead?: boolean): Observable<any> {
    const params: any = { page, size };
    if (isRead !== undefined) params['isRead'] = isRead;
    return this.http.get<any>(`${environment.baseUrl}/nsm/api/v1/user-notifications/${userId}`, { params });
  }

  markNotificationRead(notificationId: number): Observable<any> {
    return this.http.put<any>(`${environment.baseUrl}/nsm/api/v1/user-notifications/${notificationId}/read`, {});
  }

  fetchUserMenuFromServer(): Observable<any[]> {
    const url = environment.baseUrl + environment.wso2amEndPoint +
      environment.identityServerName +
      environment.wso2amApiVersion +
      '/public/v1/auth/userdetails';
    const userName = this.userInfoService.getUserName();
    return new Observable(observer => {
      this.http.post<UserTokenResponse>(url, { username: userName }).subscribe({
        next: (res: UserTokenResponse) => {
          res.appMenuJson = _.filter(res.appMenuJson, (item: any) => keepLabels.includes(item.label));
          this.applyViewActionFilter(res.appMenuJson);
          sessionStorage.setItem('modules', JSON.stringify(res.appMenuJson));
          observer.next(res.appMenuJson);
          observer.complete();
        },
        error: (err) => observer.error(err)
      });
    });
  }

  getRefreshToken(reg: any): Observable<UserTokenResponse> {
    const url = environment.baseUrl + environment.wso2amEndPoint +
      environment.identityServerName +
      environment.wso2amApiVersion +
      '/public/v1/auth/refreshToken';
    return this.http.post<UserTokenResponse>(url, reg);
  }
}
